export const NUM_DAYS = 7;
